import React from 'react'
import cx from 'classnames'
import * as R from 'ramda'

import { Box } from 'components/layout/Box/Box'
import { Icon } from 'components/shared/Icon/Icon'
import { Table } from 'components/shared/Table/Table'

import { ChevronDownIcon, ChevronUpIcon } from 'components/shared/Icon/model'

import type { TableCellProps } from 'components/shared/Table/types'
import styles from './HeaderCell.module.scss'

export const HeaderCell = ({
  className,
  maxWidth,
  sortType,
  text,
  onClick,
  hasSorting,
  alignLeft = false,
}) => {
  const cellProps: TableCellProps = {
    className: cx(styles.cell, {
      [className]: Boolean(className),
      [styles.alignLeft]: alignLeft,
    }),
    maxWidth: maxWidth,
    type: 'head',
  }

  if (R.not(hasSorting)) {
    return (
      <Table.Cell {...cellProps}>
        <span className={styles.text}>{text}</span>
      </Table.Cell>
    )
  }

  return (
    <Table.Cell {...cellProps}>
      <button className={styles.button} onClick={onClick}>
        <Box align="center" className={styles.content} tagName="span">
          <span className={styles.text}>{text}</span>
          <span className={styles.icons}>
            {sortType === 'asc' && <Icon icon={ChevronUpIcon} size={20} />}
            {sortType === 'desc' && <Icon icon={ChevronDownIcon} size={20} />}
          </span>
        </Box>
      </button>
    </Table.Cell>
  )
}
